/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'ai-floating-context-menu.ai-dynamic-surface.back': 'terug',
  'ai-floating-context-menu.ai-dynamic-surface.close': 'sluiten',
  'ai-floating-context-menu.ai-dynamic-surface.referencing-panel-title': 'Verwijzing',
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': 'Acties',
  'ai-smart-button.ai-actions.conversation-starters.loading.text': 'Gespreksstarters aan het laden ...',
  'ai-smart-button.ai-actions.conversation-starters.section.text': 'Vraag Rovo',
  'ai-smart-button.ai-actions.give-feedback-action.title': 'Feedback geven',
  'ai-smart-button.ai-actions.help.section.text': 'Help',
  'ai-smart-button.ai-actions.input.link-picker-button-label': 'Link',
  'ai-smart-button.ai-actions.input.mention-button-label': 'Vermelding',
  'ai-smart-button.ai-actions.input.placeholder': 'Typ wat je nodig hebt',
  'ai-smart-button.ai-actions.input.send-button-label': 'Verzenden',
  'ai-smart-button.ai-actions.item.betaLozenge': 'BÈTA',
  'ai-smart-button.ai-actions.item.newLozenge': 'NIEUW',
  'ai-smart-button.ai-actions.no-results-heading': 'Vraag Rovo',
  'ai-smart-button.ai-actions.no-results-text': 'Stuur je prompt naar Rovo om een chat te starten.',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': 'Pictogram toevoegen',
  'ai-smart-button.ai-actions.rovo-agents.agent-icon-label': 'Pictogram agent',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': 'Pictogram automatisering',
  'ai-smart-button.ai-actions.rovo-agents.automations.text': 'Automatiseringen',
  'ai-smart-button.ai-actions.rovo-agents.browse-agent.text': 'Agents zoeken',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'Agent aanmaken',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': 'Automatisering aanmaken',
  'ai-smart-button.ai-actions.rovo-agents.section.text': 'Studio',
  'ai-smart-button.ai-actions.static-agent-fallback-1': 'Wat zijn Rovo-Agents?',
  'ai-smart-button.ai-actions.static-agent-fallback-2': 'Hoe kan ik Rovo-Agents gebruiken in mijn Confluence-space?',
  'ai-smart-button.ai-actions.static-fallback-1': 'Wat is Rovo Chat?',
  'ai-smart-button.ai-actions.static-fallback-2': 'Help mij aan de slag gaan met Rovo Chat',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line': 'Hoe kan ik helpen?',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Hallo {name},',
  'ai-smart-button.ai-proactive-nudge.dismiss': 'Negeren',
  'ai-smart-button.feedback-action.ask-question-option': 'Stel een vraag',
  'ai-smart-button.feedback-action.can-contact-message':
    'Ja, {product}-teams mogen contact met me opnemen om te vragen naar mijn ervaringen, zodat Atlassian-producten en -diensten kunnen worden verbeterd. Ik erken het {privacyPolicy}',
  'ai-smart-button.feedback-action.cancel-button-label': 'Annuleren',
  'ai-smart-button.feedback-action.choose-feedback-option': 'Kies er een',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'De bug of issue beschrijven',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': 'Laat ons weten wat je vindt',
  'ai-smart-button.feedback-action.feedback-entry-question-heading': 'Wat zou je willen weten?',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': 'Laat ons weten wat je zou willen verbeteren',
  'ai-smart-button.feedback-action.leave-comment-option': 'Laat een opmerking achter',
  'ai-smart-button.feedback-action.privacy-policy-link': 'Privacybeleid van {product}.',
  'ai-smart-button.feedback-action.report-bug-option': 'Rapporteer een bug',
  'ai-smart-button.feedback-action.research-participation-message': 'Ik wil graag meewerken aan productonderzoek',
  'ai-smart-button.feedback-action.select-feedback-heading': 'Feedback selecteren',
  'ai-smart-button.feedback-action.submit-button-label': 'Feedback sturen',
  'ai-smart-button.feedback-action.suggest-improvement-option': 'Stel een verbetering voor',
  'ai-smart-button.feedback-action.title': 'Feedback geven',
  'ai-smart-button.feedback-item.icon-label': 'Feedbackpictogram',
  'ai-smart-button.reference.close-button-label': 'Sluiten',
  'ai-smart-button.tooltip.label': 'Rovo AI vragen',
  'quick-summary.feedback.summary.placeholder': 'Wat heeft Atlassian Intelligence goed gedaan? Wat kan er beter?',
  'quick-summary.feedback.title': 'Help ons Atlassian Intelligence te verbeteren',
};
